import { ThemeProvider as MuiThemeProvider } from '@mui/system';
import React from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { BrowserRouter as Router } from 'react-router-dom';

import RouteToNavigate from './routes';
import theme from './Theme/Theme';
import { ThemeProvider } from './context/ThemeContext';

function App() {
  return (
    <Router>
      <ThemeProvider>
        <MuiThemeProvider theme={theme}>
          <RouteToNavigate />
        </MuiThemeProvider>
      </ThemeProvider>
    </Router>
  );
}

export default App;
